//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import FormGroupBox from "@/0/components/comForm/comFormEditGroupBoxViewX";
import FormTab from "@/0/components/comForm/comTab/comFormEditTab.vue";

export default {
  props: ["groupRowItem", "dataConfig"],
  components: {
    "form-group-box": FormGroupBox,
    "form-tab": FormTab,
  },
  data() {
    return {};
  },
  created() {},
  methods: {

    $getActionObj(){
      var actionObj = this.$parent.$getActionObj();
      return actionObj;
    },
        
    
    $repostForm(url){      
      this.$parent.$repostForm(url);
    },


    getSubmitData() {
      this.$getSubmitData();
    },    

    $getSubmitData(initSubmitData) {
      // 将表单数据处理后返回
      let submitData = {};
      if(initSubmitData){
        submitData = Object.assign(submitData,initSubmitData);
      }

      if(this.groupRowItem.ControlsList){
        var groupBoxSubmitData = this.$refs.comGroupBox.$getSubmitData();
        if(groupBoxSubmitData){
          submitData = Object.assign(submitData,groupBoxSubmitData);
        }
      }
      

      var viewSubmitList = {};
      if(this.groupRowItem.ControlViewList && this.groupRowItem.ControlViewList.length > 0){

        this.groupRowItem.ControlViewList.forEach(m=>{
          var thisView = this.$refs['comView_' + m.OpenId];
          if(thisView && thisView.length > 0){
            thisView = thisView[0];
          }

          if(!thisView) return null;

          var thisSubmit = thisView.$getSubmitData();
          console.log("thisView===thisSubmit",thisSubmit);
          viewSubmitList = Object.assign(viewSubmitList, thisSubmit);
        });
      }
      if(viewSubmitList){
        submitData = Object.assign(submitData,viewSubmitList);
      }
      
      console.log("--submitData",submitData);
      return submitData;
    }

  }
};
